<template>
  <div>
    <h4 class="workplatform-title m-t-10 m-b-10">合同基本信息</h4>
    <Row>
      <i-col span="8">
        <label class="title text-title-65">合同编号</label>{{ contractInfo.code }}
        <a class="m-l-5" @click="showContractDetail"><Icon type="md-search" />查看合同详情</a>
      </i-col>
      <i-col span="8">
        <span class="title text-title-65">合同名称</span>{{ contractInfo.name }}
      </i-col>
      <i-col span="8">
        <span class="title text-title-65">客户名称</span>{{ contractInfo.advertiserName }}
        <template v-if="contractInfo.secondParty">
          <Tag v-if="contractInfo.secondParty.partyType===10" color="green">企业</Tag>
          <Tag v-else color="cyan">个人</Tag>
        </template>
      </i-col>
    </Row>
    <Row class="p-b-5">
      <i-col span="8">
        <span class="title text-title-65">开始日期</span>{{ contractInfo.startDate }}
      </i-col>
      <i-col span="8">
        <span class="title text-title-65">结束日期</span>{{ contractInfo.endDate }}
      </i-col>
      <i-col span="8">
        <span class="title text-title-65">用途</span>{{ contractInfo.rentTypeName }}
      </i-col>
    </Row>
    <Row class="p-b-5">
      <i-col span="8">
        <span class="title text-title-65">创建人</span>{{ contractInfo.createUserName }}
      </i-col>
      <i-col span="8">
        <span class="title text-title-65">创建时间</span>{{ contractInfo.createTime }}
      </i-col>
    </Row>
    <Row>
      <i-col span="24">
        <span class="title text-title-65">附加条款</span>{{ contractInfo.description }}
      </i-col>
    </Row>

    <h4 class="workplatform-title m-t-10 m-b-10">用电记录</h4>
    <Row class="m-b-5">
      <i-col flex="320px">
        <DatePicker type="month" size="small" placeholder="选择计价开始日期" clearable style="width: 150px"></DatePicker>
        <DatePicker type="month" size="small" class="m-l-10" placeholder="选择计价结束日期" clearable style="width: 150px"></DatePicker>
      </i-col>
      <i-col flex="250px">
        <i-input size="small" v-model="query.keyWord" placeholder="关键字：支持资源编号、电表编号"></i-input>
      </i-col>
      <i-col flex="auto">
        <Button type="primary" icon="ios-search" class="m-l-5" size="small" @click="onSearchData">搜索</Button>
      </i-col>
    </Row>
    <Table size="small" stripe  show-summary :summary-method="handleSummary" :data="tableData" :loading="tableLoading" :columns="tableColumns"></Table>

    <Modal v-model="modalShowContractDetail" title="合同详情" footer-hide width="1200">
      <contractDetail ref="contractDetail"/>
    </Modal>
  </div>
</template>

<script>
import contractDetail from '@/components/investmentContract/modalComponents/detail.vue'

import { toMoney } from '@/utils/wnumb_own'
import { formatDebtStatus } from '@/utils/tagStatus'

import { getContractInfo } from '@/api/invest/contract'
import { pageElectricMeterRecord } from '@/api/invest/electricMeterRecord'

export default {
  props: {},
  components: {
    contractDetail
  },
  data () {
    return {
      contractInfo: {},
      modalShowContractDetail: false,

      query: {
        current: 1,
        size: 15,
        meterId: null,
        assetId: null,
        keyWord: null,
        stationId: null,
        contractId: null
      },

      tableLoading: false,
      tableData: [],
      tableColumns: [
        { title: '资源编号', key: 'deviceCode' },
        { title: '电表编号', key: 'meterCode' },
        { title: '最近抄表时间', key: 'readDate' },
        { title: '上期读数/底表读数', key: 'lastValue' },
        { title: '本期读表数', key: 'currentValue' },
        { title: '本期用电量(kwh)', key: 'electricityConsume' },
        { title: '线损', key: 'lineLost' },
        { title: '电费单价', key: 'unitPrice' },
        { title: '本期电费合价(元)', key: 'chargeAmount' },
        { title: '计价月份', key: 'chargeMonthStr' },
        {
          title: '账单状态',
          width: 100,
          align: 'center',
          render: (h, params) => {
            return formatDebtStatus(
              h,
              params.row.status,
              params.row.statusName
            )
          }
        }
      ]
    }
  },
  mounted () {},
  created () {
    if (this.contractId) {
      this.initDetail()
    }
  },
  methods: {
    initDetail () {
      // 载入用电记录
      this.query.contractId = this.contractId
      this.loadElectricMeterRecord()

      // 载入合同信息
      getContractInfo({ contractId: this.contractId }).then(res => {
        this.contractInfo = res
      })
    },
    loadElectricMeterRecord () {
      this.tableLoading = true
      pageElectricMeterRecord(this.query).then(res => {
        this.tableData = res.records
        this.totalRow = res.total
        this.tableLoading = false
      })
    },
    handleSummary ({ columns, data }) {
      const sums = {}
      const needSummarykey = [
        'nowUse',
        'amount'
      ]

      columns.forEach((column, index) => {
        const key = column.key
        if (index === 0) {
          sums[key] = {
            key,
            value: '合计'
          }
          return
        }

        if (needSummarykey.includes(key)) {
          const values = data.map((item) => Number(item[key]))
          if (!values.every((value) => isNaN(value))) {
            const v = values.reduce((prev, curr) => {
              const value = Number(curr)
              if (!isNaN(value)) {
                return prev + curr
              } else {
                return prev
              }
            }, 0)
            sums[key] = {
              key,
              value: (key === 'amount') ? toMoney(v) : v
            }
          } else {
            sums[key] = {
              key,
              value: '-'
            }
          }
        } else {
          sums[key] = {
            key,
            value: '-'
          }
        }
      })

      return sums
    },
    showContractDetail () {
      this.modalShowContractDetail = true
      this.$refs.contractDetail.initBaseData(this.contractId)
    },
    onSearchData () {
      this.query.current = 1
      this.loadElectricMeterRecord()
    },
    handleChangePage (currentPage) {
      this.query.current = currentPage
      this.loadElectricMeterRecord()
    }
  },
  watch: {
    contractId () {
      this.initDetail()
    }
  },
  computed: {
    contractId () {
      return this.$store.state.investmentElecConsumption.contractId
    }
  }
}
</script>
